import { useEffect, useState } from "react";
import useUserStore from "../stores/user";
import ForceResetPasswordBlock from "./ForceResetPasswordBlock";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const [requiresReset, setRequiresReset] = useState(false);
  const user = useUserStore((state) => state.user);

  useEffect(() => {
    setRequiresReset(user?.user_metadata?.forceResetPassword ?? false);
  }, [user]);

  if (requiresReset) {
    return <ForceResetPasswordBlock />;
  }

  return <>{children}</>;
}
